var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartLockOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 7.5C8.5 4.46243 10.9624 2 14 2C14.5523 2 15 2.44772 15 3C15 3.55228 14.5523 4 14 4C12.067 4 10.5 5.567 10.5 7.5V10C10.5 10.5523 10.0523 11 9.5 11C8.94772 11 8.5 10.5523 8.5 10V7.5Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 7.5C19.5 4.46243 17.0376 2 14 2C13.4477 2 13 2.44772 13 3C13 3.55228 13.4477 4 14 4C15.933 4 17.5 5.567 17.5 7.5V10C17.5 10.5523 17.9477 11 18.5 11C19.0523 11 19.5 10.5523 19.5 10V7.5Z",
    fill: "#023F80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 14.8337C3.5 11.5634 6.26778 9 9.54688 9C11.2301 9 12.7179 9.63167 13.9943 10.8049C15.2597 9.62862 16.7525 9 18.4531 9C21.7322 9 24.5 11.5634 24.5 14.8337C24.5 16.5709 24.0211 17.9125 22.8693 19.2886C21.7804 20.5893 20.0734 21.9372 17.6724 23.7504L17.6692 23.7528L15.2012 25.6016C14.4921 26.1328 13.5079 26.1328 12.7988 25.6016L10.3308 23.7528L10.3276 23.7504C7.92661 21.9372 6.21955 20.5893 5.13072 19.2886C3.97891 17.9125 3.5 16.5709 3.5 14.8337ZM9.54688 11C7.2843 11 5.5 12.754 5.5 14.8337C5.5 16.0999 5.81276 16.9875 6.66435 18.0048C7.57874 19.0972 9.08638 20.3067 11.5314 22.1533C11.5319 22.1537 11.5324 22.154 11.533 22.1544L13.9962 23.9997C13.997 23.9998 13.9982 24 14 24C14.0018 24 14.003 23.9998 14.0038 23.9997L16.467 22.1544C16.4676 22.154 16.4681 22.1537 16.4686 22.1533C18.9136 20.3067 20.4213 19.0972 21.3356 18.0048C22.1872 16.9875 22.5 16.0999 22.5 14.8337C22.5 12.754 20.7157 11 18.4531 11C17.078 11 15.8611 11.5835 14.7677 12.8934C14.5789 13.1196 14.2998 13.2511 14.0051 13.2526C13.7104 13.2541 13.4301 13.1255 13.2389 12.9012C12.1136 11.5809 10.8923 11 9.54688 11Z",
    fill: "#023F80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 15C14.5523 15 15 15.4477 15 16V18C15 18.5523 14.5523 19 14 19C13.4477 19 13 18.5523 13 18V16C13 15.4477 13.4477 15 14 15Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartLockOutline);
export default __webpack_public_path__ + "static/media/heart_lock_outline.6ba0c0e385750e4368440808d1e0892f.svg";
export { ForwardRef as ReactComponent };